<!-- eslint-disable max-len -->
<template>
  <div class="cf-gift-card--details cf-credit-card--scan-to-pay">
    <svg
      class="cf-emv-chip"
      viewBox="0 0 216 154"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 25C0 11.1929 11.1929 0 25 0H191C204.807 0 216 11.1929 216 25V129C216 142.807 204.807 154 191 154H25C11.1929 154 0 142.807 0 129V25Z"
        fill="#FAD157"
      />
      <path
        d="M3.9999 25C3.9999 13.402 13.4019 4 24.9999 4H191C202.598 4 212 13.402 212 25V129C212 140.598 202.598 150 191 150H24.9999C13.4019 150 3.9999 140.598 3.9999 129V25Z"
        stroke="#D89330"
        stroke-width="8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108 108C125.121 108 139 94.1208 139 77C139 59.8792 125.121 46 108 46C90.879 46 76.9998 59.8792 76.9998 77C76.9998 94.1208 90.879 108 108 108ZM108 116C129.539 116 147 98.5391 147 77C147 55.4609 129.539 38 108 38C86.4607 38 68.9998 55.4609 68.9998 77C68.9998 98.5391 86.4607 116 108 116Z"
        fill="#D89330"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M124 8H91.9998V146H124V8ZM83.9998 0V154H132V0H83.9998Z"
        fill="#D89330"
      />
      <rect
        x="91.9998"
        y="16"
        width="32"
        height="113"
        fill="#FAD157"
      />
      <rect
        x="212"
        y="57"
        width="40"
        height="208"
        transform="rotate(90 212 57)"
        stroke="#D89330"
        stroke-width="8"
      />
      <circle
        cx="108"
        cy="77"
        r="31"
        fill="#FAD157"
      />
    </svg>

    <svg
      class="cf-card-number"
      viewBox="0 0 300 20"
      preserveAspectRatio="xMinYMid meet"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="0"
        y="18"
        font-size="18"
        fill="black"
      >{{ `${paymentMethod.cardType.toLowerCase() === 'amex' ? '•••• •••••• •' : '•••• •••• •••• '}${paymentMethod.displayText}` }}</text>
    </svg>

    <cf-card-type-icon
      class="cf-card-type-badge"
      :card-type="paymentMethod.cardType"
      size="large"
    />

    <svg
      class="cf-cardholder-name"
      viewBox="0 0 300 15"
      preserveAspectRatio="xMinYMid meet"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="0"
        y="14"
        font-size="14"
        fill="black"
      >{{ paymentMethod.nameOnCard }}</text>
    </svg>
  </div>
</template>


<script>
  import CfCardTypeIcon from '@/view/components/shared/cf-card-type-icon/index.vue';


  export default {
    name: 'CfCreditCardDisplay',

    components: {
      CfCardTypeIcon
    },

    props: {
      paymentMethod: {
        type: Object,
        required: true
      }
    }
  };
</script>
